import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { User } from '/@/modules/user/models/User';

export class UserService extends BaseEntityService<User> {
  getRoute(): Route {
    return Route.USERS;
  }

  getModel(): typeof User {
    return User;
  }

  getPrimaryExecutor(): Promise<User[]> {
    return this.getEntities({
      user_estate_primary_executor: true,
      one: true
    });
  }

  getPlanner(): Promise<User[]> {
    return this.getEntities({
      user_is_planner: true,
      one: true,
      with: ['estateAccounts']
    });
  }

  getPartner(): Promise<User[]> {
    return this.getEntities({
      user_is_partner: true,
      one: true
    });
  }
}

export default new UserService();
